import React from 'react';
import { Modal, Button, Spinner } from 'react-bootstrap';
import './CustomModal.css';

const CustomModal = ({ 
  show,
  onHide, 
  headerIcon, 
  headerText, 
  body, 
  onSave ,
  secondaryBtnText,
  onSecondaryClick,
  size, 
  variant, 
  btnText, 
  isLoading, 
  btnCancelText, 
  dFlexBtn, 
  closeButton = true, 
  onUndoChanges, 
  hideSaveBtn, 
  footerStyle, 
  isAlsoDeleteModal, 
  scrollable,
  setIsConfirmDeleteStateArea,
  isConfirmDeleteStateArea,
  onDeleteAreaOrSottoarea,
  isLoadingAreaOrSottoareaDelete,
  hideButtons,
}) => {

   
  return (
    <Modal show={show} onHide={onHide} centered size={size} scrollable={scrollable} dialogClassName="custom-modal-dialog">
      <Modal.Header closeButton={closeButton} className='bg-secondary'>
        <Modal.Title className="text-break flex-grow-1 pe-2">
          {headerIcon && <headerIcon />}
          {headerText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='p-4 text-break'>{body}</Modal.Body>
      {
        !hideButtons && (
          <Modal.Footer className={`p-4 d-flex flex-column flex-sm-row flex-wrap gap-2 align-items-stretch align-items-sm-center ${dFlexBtn ? 'justify-content-sm-between' : 'justify-content-end'} ${footerStyle || ''}`}>
          {hideSaveBtn ? '' : (
            isLoading ? (
              <Button variant={variant} disabled className="w-100 w-sm-auto">
                  <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  className="me-2"
              />
                Caricamento...
              </Button>
            ) : (
              <>
            {!isConfirmDeleteStateArea && (
              <>
                <Button variant={variant} onClick={onSave} className="w-100 w-sm-auto">
                  {btnText}
                </Button>

                {/* Secondo bottone opzionale */}
                {onSecondaryClick && secondaryBtnText && (
                  <Button 
                    variant={variant} 
                    onClick={onSecondaryClick} 
                    className="w-100 w-sm-auto"
                  >
                    {secondaryBtnText}
                  </Button>
                )}
              </>
            )}
              </>
          ) 
          )}
          {!isAlsoDeleteModal ? 
            <Button variant="secondary" onClick={() => (onUndoChanges ?? onHide)?.()} className="w-100 w-sm-auto">
              {btnCancelText ?? 'Annulla'}
            </Button>
          : 
          <>
                { !isConfirmDeleteStateArea && ( 
                <Button variant="danger" onClick={() => setIsConfirmDeleteStateArea(true)} className="w-100 w-sm-auto">
                  Elimina
                </Button>
                ) }
                { isConfirmDeleteStateArea && ( 
                  <>
                  {  isLoadingAreaOrSottoareaDelete ? 
                        <Button variant="success" disabled className="w-100 w-sm-auto">
                        <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                    />
                      Caricamento...
                    </Button>
                  : 
                    <Button variant="success" onClick={onDeleteAreaOrSottoarea} className="w-100 w-sm-auto">
                      Conferma eliminazione
                    </Button>
                    
                    }
                    <Button variant="secondary" onClick={() => setIsConfirmDeleteStateArea(false)} className="w-100 w-sm-auto">
                      annulla
                    </Button>
                  </>
                ) }
          </>
          }
          </Modal.Footer>
        )
      }
    </Modal>
  );
};

export default CustomModal;
